"use strict";
angular.module("planCommandMonitorAreaHotspotsModule", [])
    .controller('planCommandMonitorAreaHotspotsCtrl', ['$scope', 'planCommandMonitorService', 'trsHttpService', '$q', '$stateParams', '$filter', '$state', 'resourceCenterService', 'modalDialog',
        function($scope, planCommandMonitorService, trsHttpService, $q, $stateParams, $filter, $state, resourceCenterService, modalDialog) {
            initStatus();
            initData();
            /**  
             * [initData description:初始化数据]
             */
            function initData() {
                requestData();
            }
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status = {
                    curroute: ["策划中心", "指挥监测中心", "添加功能", "功能配置/功能说明"],
                };

            }
            /**
             * [requestData description:获取数据]
             */
            function requestData() {
                var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'getaddfunclist',
                    "sceneid": $stateParams.sceneid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.addState = data.listr[0].addFlg;
                    $scope.hotData = data.listr[0];
                });
            }
            $scope.addHotMgr = function() {
                var addParams = { //添加功能或者保存功能时需要的接口参数
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'addFuncAreaHot',
                    "sceneid": $stateParams.sceneid,
                    "addFlag": ($stateParams.addflg === "true") ? 1 : 0,
                    "userroleid": $scope.hotData.userRoleId
                };

                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), addParams, 'post').then(function(data) {
                    if (data.mapResult.status === 'SUCCESS') {
                        modalDialog.alertType("", "添加成功", "success", true, function() {
                               $state.go('front.planningresource.commandMonitor.regionalhotspots', {}, { reload: "front.planningresource" });
                            },
                            function() {
                                requestData();
                            }, "", "留在当前页", "立即查看");
                    } else {
                        modalDialog.alertType("", "添加失败请重新更新", "error", "confirm");
                    }

                });
            };
        }
    ]);